import { sagas as rentableItems } from './modules/rentableItems'
import { sagas as rentedItems } from './modules/rentedItems'

export default [...rentableItems, ...rentedItems]
